
<ng-template [ngIf]="isUpdatingListino">
    <app-loading></app-loading>
</ng-template>
  <div class="d-flex mt-2">
           <form [formGroup]="modificaListinoForm">
              <div class="grid formgrid p-fluid">
                  
                  <div class="field mt-2 mb-2 col-2">
                      <label for="scl1" class="font-medium text-900 text-blue-600">SCL.1</label>
                      <p-inputNumber mode="currency" inputId="scl1" currency="EUR" locale="it-IT" formControlName="scl1" [styleClass]="'right-align'"> </p-inputNumber>
                  </div>
                  <div class="field mt-2 mb-2 col-2">
                      <label for="scl2" class="font-medium text-900 text-blue-600">SCL.2</label>
                      <p-inputNumber mode="currency" inputId="scl2" currency="EUR" locale="it-IT" formControlName="scl2" [styleClass]="'right-align'"> </p-inputNumber>
                  </div>
                  <div class="field mt-2 mb-2 col-2">
                      <label for="scl3" class="font-medium text-900 text-blue-600">SCL.3</label>
                      <p-inputNumber mode="currency" inputId="scl3" currency="EUR" locale="it-IT" formControlName="scl3" [styleClass]="'right-align'"> </p-inputNumber>
                  </div>
                  <div class="field mt-2 mb-2 col-2">
                      <label for="scl4" class="font-medium text-900 text-blue-600">SCL.4</label>
                      <p-inputNumber mode="currency" inputId="scl4" currency="EUR" locale="it-IT" formControlName="scl4" [styleClass]="'right-align'"> </p-inputNumber>
                  </div>
                  <div class="field mt-2 mb-2 col-2">
                      <label for="scl5" class="font-medium text-900 text-blue-600">SCL.5</label>
                      <p-inputNumber mode="currency" inputId="scl5" currency="EUR" locale="it-IT" formControlName="scl5" [styleClass]="'right-align'"> </p-inputNumber>
                  </div>
                  <div class="field mt-2 mb-2 col-2">
                      <label for="preventivoBase" class="font-medium text-900 text-blue-600">Preventivo Base</label>
                      <p-inputNumber mode="currency" inputId="preventivoBase" currency="EUR" locale="it-IT" formControlName="preventivoBase" [styleClass]="'right-align'"> </p-inputNumber>
                  </div>
              </div> 
          </form>
      
      
      
  </div>




<div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

<div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
  <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
  styleClass="p-button-warning"></p-button>
 <p-button  icon="pi pi-check" label="Conferma"
  class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isUpdatingListino || !modificaListinoForm.valid"></p-button>

</div>
<p-toast />
<p-confirmDialog /> 